module.exports = __webpack_public_path__ + "static/media/table_setting.48c796c8.jpg";